import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const CuratorPortal = lazy(() => import("@/pages/CuratorPortal"));

export const Route = createFileRoute("/curator-portal")({
  component: CuratorPortal,
});
